<template>
    <v-container>
      <template>
        <div class="text-center">
            <v-dialog
                v-model="dialog"
                width="800"
                @click:outside="closeModal"
                :retain-focus="false"
                persistent
            >
            <v-card class="" rounded="0" >
              <v-toolbar flat color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">{{
                  $t("Add New Record")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text class="py-5">
                <v-row  >
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('dashboardS.matingDate')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" size="20">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.matingDateH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <v-menu
                            v-model="matingDateMenuSE"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            v-model="animal.semenEmbryoMatingDate"
                            append-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :placeholder="$t('animal.conceptionInfo.selectDate')"
                            @click:append="matingDateMenuSE = true"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="animal.semenEmbryoMatingDate"
                            @input="matingDateMenuSE = false"
                        ></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label >{{$t('dashboardS.sireId')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span>{{$t('animal.conceptionInfo.sireIdH')}}.</span>
                            </v-tooltip>
                        </label>
                      <AnimalDropdown v-model="animal.sireId" animalType="sire" :currentAnimal="$route.params.animal_number"/>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('dashboardS.srgDamId')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.sarogatedDamH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <AnimalDropdown v-model="animal.surrogateDamId" animalType="dam" :currentAnimal="$route.params.animal_number"/>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('dashboardS.embOrgName')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.embOrgNameH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <v-text-field
                            type="text"
                            outlined
                            dense
                            v-model="animal.embryoOrgName"
                            :placeholder="$t('animal.conceptionInfo.selectEmbryoOrganisation')"
                            :rules="[(v) => {
                                if (v)
                                return (
                                    !Number(v) ||
                                    $t('animal.conceptionInfo.orgnisationNameContainNumber')
                                );
                            },
                            ]"
                        ></v-text-field>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('dashboardS.srgDamBreed')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.sarogateDamBreedH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <v-autocomplete
                            v-model="animal.surrogateDamBreedId"
                            :items="breeds"
                            outlined
                            dense
                            item-text="name"
                            item-value="name"
                        >
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col sm="12" md="6">
                        <label class="subtitle-2 black--text text-no-wrap">{{$t('dashboardS.sireBreed')}}
                            <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                </v-icon>
                                </template>
                                <span
                                >{{$t('animal.conceptionInfo.sireBreedH')}}.</span
                                >
                            </v-tooltip>
                        </label>
                        <v-autocomplete
                            v-model="animal.sireBreedId"
                            :items="breeds"
                            outlined
                            dense
                            item-text="name"
                            item-value="name"
                        >
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                </template>
                                <template v-else>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                </v-list-item-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <hr>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" outlined n-width="50px" @click="closeModal">Cancel</v-btn>
                    <v-btn color="primary" min-width="50px" @click="registerConception">Submit</v-btn>
                </v-card-actions>
            </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <DataLostWarning
        :dialogI="dataLossWarning"
        v-if="dataLossWarning"
        @closeDialog="closeWarningMessage"
        @saveData="closeWarningMessage"
      ></DataLostWarning>
    </v-container>
  </template>
  
  <script>
  import loadingMixin from "@/mixins/LoadingMixin";
  import generalMixin from "@/mixins/GeneralMixin";
//   import GeneralService from "@/_services/GeneralService";
  import AnimalService from "@/_services/AnimalService";
  import AnimalDropdown from "@/components/AnimalDropdown.vue";
  import { breeds } from "@/models/units.js";

  export default {
    components: {
        AnimalDropdown
    },
    created() {
        this.assignValue()
    },
    computed: {
      dialog() {
        return this.dialogI;
      },
    },
    data() {
      return {
        breeds,
        matingDateMenuSE: false,
        dataLossWarning: false,
        animal: {
            animalNumber: this.$route.params.animal_number,
            semenEmbryoMatingDate: "", //(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            sireId: "",
            surrogateDamId: "",
            embryoOrgName: "",
            surrogateDamBreedId: "",
            sireBreedId: "",
        },
      };
    },
    methods: {
        assignValue() {
            this.animal.id = this.editedItem.id
            this.animal.semenEmbryoMatingDate = this.editedItem.matingDate
            this.animal.sireId = this.editedItem?.sire?.animalNumber || ""
            this.animal.surrogateDamId = this.editedItem?.surrogateDam?.animalNumber || ""
            this.animal.embryoOrgName = this.editedItem.embryoOrgName
            this.animal.sireBreedId = this.editedItem.sireBreed
            this.animal.surrogateDamBreedId = this.editedItem.surrogateDamBreed
            console.log(this.editedItem)
        },
      closeWarningMessage(res) {
        this.dataLossWarning = false;
        if (!res) {
          this.$emit("closeAddUser");
        }
      },

      closeModal() {
        this.dataLossWarning = true;
      },
      registerConception() {
        let isEmpty = true
        Object.entries(this.animal).forEach(([key, value]) => {
            if(key != 'animalNumber' && value != ""){
                isEmpty = false
                console.log(key, value)
            }
        })

        if(isEmpty){
            this.$notify({
                title: this.$t('Nothing to add'),
                type: "error"
            });
            return;
        }
        this.startLoading();
        this.formChanged = false;
        AnimalService.updateAnimalConception(this.animal, 'semenemb')
            .then((res) => {
            if (res.success) {
                this.$notify({
                title: this.$t('animal.conceptionInfo.animalConceptionAddedSuccessfully'),
                text: res.message,
                type: "success",
                position: "top right",
                });
            } else {
                this.$notify({
                title: this.$t('somethingWentWrong'),
                text: res.message,
                type: "error",
                position: "top right",
                });
            }
            this.$emit('added')
            this.stopLoading();
            })
            .catch((err) => {
            console.log(err.data);
            this.stopLoading();
            });
    },
  
    },
    props: {
      dialogI: {
        type: Boolean,
        required: true,
      },
      editedItem: {
        type: Object,
        required: true
      }
    },
    mixins: [loadingMixin, generalMixin],
  };
  </script>
  
  <style>

  </style>
  